import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20golden%20amber%20abstract%20gradient%20background%2C%20soft%20flowing%20curves%20and%20geometric%20patterns%2C%20elegant%20minimalist%20composition%2C%20warm%20atmospheric%20light%2C%20sophisticated%20modern%20design%2C%20smooth%20blended%20tones&width=1800&height=600&seq=cta-bg-cheng91&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 via-background-950/60 to-background-950/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          准备好开始使用成91了吗？
        </h2>
        <p className="text-background-300 mb-8 max-w-xl mx-auto">
          立即访问成91官方平台，体验安全、便捷、高效的在线服务。收藏本页获取成91最新入口与使用指南。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/shiyong-jiaocheng"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg text-base font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            开始使用教程
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-lg text-base font-medium hover:bg-background-50/20 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}